import router from "./router";
import storage from "store";
import store from "@/store/index";
import * as request from "@/request/common";
import { setDocumentTitle } from "@/utils/domUtil";
import login from "@/utils/login";
import getRouteList from "@/router/permission.router";
import { getHashParams } from "@/utils/common";

// 获取用户信息
const getUserInfo = (to, next, headers) => {
    return new Promise((resolve, reject) => {
        request
            .get({ url: "GetUserInfoByUserId" })
            .then((res) => {
                store.commit("updateState", { userInfo: res.data });
                let query = JSON.parse(JSON.stringify(to.query));
                query.unified && delete query.unified;
                // 获取路由权限
                getRouteList(headers)
                    .then(() => {
                        next({
                            path: to.path,
                            replace: true,
                            query,
                        });
                        resolve();
                    })
                    .catch(() => {
                        let meetingID = getHashParams("meeting_id");
                        let language = getHashParams("lang");
                        next({
                            path: `/no-auth/${language}/${meetingID}`,
                            replace: true,
                        });
                        reject();
                    });
            })
            .catch((err) => {
                console.log(err);
                reject();
            });
    });
};

router.beforeEach(async (to, from, next) => {
    // 设置标题|描述|关键字
    if (to.meta && typeof to.meta?.name !== "undefined") {
        setDocumentTitle(to.meta?.name);
    }

    // 存论坛名称
    if (to.query.title) {
        window.sessionStorage.setItem("forum_name", to.query.title);
    }

    let meetingID = getHashParams("meeting_id");
    let language = getHashParams("lang");
    let forumID = getHashParams("forum_id");

    const meetingInfo = await store.dispatch("getMeetingInfo", {
        meetingID,
        language,
        forumID,
    });

    // 如果参数中存在unified则代表需要登录
    if (to.query.unified && !store.getters.userInfo?.Mobile) {
        request
            .post({
                url: "UnifiedLogin",
                data: {
                    unified: to.query.unified,
                },
            })
            .then((res) => {
                storage.set("token", res.data);
                // 获取用户信息
                getUserInfo(to, next, { meetingID, language, forumID }).then(
                    () => {}
                );
            });
    } else {
        let auth = storage.get("token");
        // 不需要登录
        if (to.meta.no_auth) {
            next();
        } else {
            // 存在token 不存在登录信息
            if (auth) {
                if (!store.getters.userInfo?.user_id) {
                    // 获取用户信息
                    getUserInfo(to, next, {
                        meetingID,
                        language,
                        forumID,
                    }).then(() => {});
                } else {
                    next();
                }
            } else {
                login();
            }
        }
    }
});

router.afterEach((to, from) => {
    // 因为列表页加了缓存，故每次切换页面时都需要做一个置顶操作
    // window.scrollTo && window.scrollTo(0, 0);
});
